import type { DocumentResult as DocumentResultType } from '@creanizer/types'
import { TwitterViewer } from './viewers/TwitterViewer'
import { NewspaperViewer } from './viewers/NewspaperViewer'
import { DiaryViewer } from './viewers/DiaryViewer'
import { ReportViewer } from './viewers/ReportViewer'
import { BlogViewer } from './viewers/BlogViewer'
import { EmailViewer } from './viewers/EmailViewer'
import { LetterViewer } from './viewers/LetterViewer'
import { MemoViewer } from './viewers/MemoViewer'
import { MedicalViewer } from './viewers/MedicalViewer'
import { PoliceViewer } from './viewers/PoliceViewer'
import { AcademicViewer } from './viewers/AcademicViewer'
import { GovernmentViewer } from './viewers/GovernmentViewer'
import { MagazineViewer } from './viewers/MagazineViewer'
import { LineViewer } from './viewers/LineViewer'
import { HistoryViewer } from './viewers/HistoryViewer'
import { CustomViewer } from './viewers/CustomViewer'

interface DocumentResultProps {
  document: DocumentResultType
  visualStyle?: string
  imageAssets?: {
    avatars?: { [key: string]: string }
    headerImage?: string
  }
}

export function DocumentResult({ document, visualStyle, imageAssets }: DocumentResultProps) {
  // 文献タイプに応じて適切なビューアーを選択
  switch (document.type) {
    case 'sns_twitter':
      return <TwitterViewer document={document as any} imageAssets={imageAssets} />
    
    case 'newspaper':
      return <NewspaperViewer document={document as any} visualStyle={visualStyle} />
    
    case 'diary':
      return <DiaryViewer document={document as any} visualStyle={visualStyle} />
    
    case 'report':
      return <ReportViewer document={document as any} />
    
    case 'blog':
      return <BlogViewer document={document as any} imageAssets={imageAssets} />
    
    case 'email':
      return <EmailViewer document={document as any} />
    
    case 'letter':
      return <LetterViewer document={document as any} />
    
    case 'memo':
      return <MemoViewer document={document as any} visualStyle={visualStyle} />
    
    case 'medical':
      return <MedicalViewer document={document as any} />
    
    case 'police':
      return <PoliceViewer document={document as any} />
    
    case 'academic':
      return <AcademicViewer document={document as any} />
    
    case 'government':
      return <GovernmentViewer document={document as any} />
    
    case 'magazine':
      return <MagazineViewer document={document as any} visualStyle={visualStyle} />
    
    case 'line':
      return <LineViewer document={document as any} imageAssets={imageAssets} />
    
    case 'history':
      return <HistoryViewer document={document as any} visualStyle={visualStyle} />
    
    case 'custom':
      return <CustomViewer document={document as any} />
    
    default:
      // フォールバック表示
      const unknownDoc = document as DocumentResultType
      return (
        <div className="p-6 bg-gray-50 rounded-lg">
          <h3 className="text-lg font-semibold mb-4">
            生成された文献（タイプ: {unknownDoc.type}）
          </h3>
          <pre className="text-sm text-gray-700 whitespace-pre-wrap">
            {JSON.stringify(unknownDoc, null, 2)}
          </pre>
        </div>
      )
  }
}